import React from "react";

//helper
import { getImageAsset } from "../../../../helpers/Images";

//components
import UserActivityImage from "../userActivities/userActivityImage";
import Icon from "../../icons/Icon";

//interfaces
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";
import { IProfileImages } from "../../../../interfaces/image/image";



const UserActivityProfileImage = ({profileImageUrl, userActivity, secondProfileImageUrl, defaultSecondProfileImage} :IProfileImages) => {   

  return (
    <div className={`user-activity-profile-image-wrapper`} aria-hidden="true">
        { profileImageUrl
            ?   <img src={getImageAsset(30, profileImageUrl) } className={`profile-image`} alt=""/>
            :   <Icon className={"default-no-user-icon"} iconName={IconLibrary.USER_NONE} sizeInPx="14" color={"var(--thriveLightSlate)"}/>
        }
        
        <UserActivityImage activity={userActivity} />

        {secondProfileImageUrl && <img src={getImageAsset(30, secondProfileImageUrl) } className={`second-profile-image`} alt=""/>}

        {defaultSecondProfileImage && <Icon className={"default-no-user-icon second-default-image"} iconName={IconLibrary.USER_NONE} sizeInPx="14" color={"var(--thriveLightSlate)"}/>}
    </div>
  );
}

export default UserActivityProfileImage